module.exports = __webpack_public_path__ + "img/a2.524aea42.png";